import { render } from "./AskAs.vue?vue&type=template&id=70a5dbfe&scoped=true"
import script from "./AskAs.vue?vue&type=script&lang=js"
export * from "./AskAs.vue?vue&type=script&lang=js"

import "./AskAs.vue?vue&type=style&index=0&id=70a5dbfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a5dbfe"]])

export default __exports__